export default __webpack_public_path__ + "static/media/img--design-3.41150da3.jpg";